module.exports = __webpack_public_path__ + "img/p5.c910045b.png";